// src/utils/phone.js

/** Digits only, max 10 — 9179981316 jaisa number jaisa typed waisa rahega */
export function sanitizePhoneInputDigits(raw, maxLen = 10) {
  let d = String(raw || "").replace(/\D/g, "");
  if (!d) return "";

  if (d.startsWith("0")) d = d.replace(/^0+/, "");

  // Sirf country code hatao jab 10 se zyada digit hon (e.g. paste +91 9179981316)
  while (d.startsWith("91") && d.length > 10) {
    d = d.slice(2);
  }

  if (d.length > maxLen) d = d.slice(-maxLen);
  return d.slice(0, maxLen);
}

export function toISD(mobile) {
  const ten = toTenDigitMobile(mobile);
  return ten ? `+91${ten}` : "";
}

/** 10 digit, pehla digit 6–9 (9179981316 valid hai) */
export function isValidIndianPhoneInput(value) {
  const d = sanitizePhoneInputDigits(value);
  return /^[6-9]\d{9}$/.test(d) && d.length === 10;
}

export function toTenDigitMobile(mobile) {
  const d = sanitizePhoneInputDigits(mobile);
  if (!/^[6-9]\d{9}$/.test(d) || d.length !== 10) return "";
  return d;
}

export function readBbUserContact() {
  try {
    const parsed = JSON.parse(localStorage.getItem("bb_user") || "null");
    if (!parsed || typeof parsed !== "object") {
      return { name: "", email: "", mobile: "", userId: "", token: "" };
    }
    return {
      name: String(parsed.name || "").trim(),
      email: String(parsed.email || "").trim(),
      mobile: toTenDigitMobile(parsed.mobile || parsed.phone || parsed.contact),
      userId: String(parsed.id || parsed._id || "").trim(),
      token: parsed.token || "",
    };
  } catch {
    return { name: "", email: "", mobile: "", userId: "", token: "" };
  }
}
